import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AdminPurchaseOrdersFacade } from './admin-purchase-orders.facade';
import {
  CreateAndSendPurchaseOrderDto,
  PurchaseOrder,
  PurchaseOrderContractData,
  UpsertPurchaseOrderDto,
} from '@models/resources/purchase-order.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante der Staff-Kaufauftrag-Actions (Sprint 9, ADR-011).
 * Wire-Shape matched das BE 1:1, kein Mapping nötig.
 */
@Injectable()
export class HttpAdminPurchaseOrdersFacade implements AdminPurchaseOrdersFacade {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/purchase-orders`;
  private readonly txBase = `${environment.apiUrl}/transaction-requests`;

  createAndSend(txId: number, dto: CreateAndSendPurchaseOrderDto): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(
      `${this.txBase}/${txId}/purchase-order/create-and-send`,
      dto,
    );
  }

  lastContract(customerId: number): Observable<PurchaseOrderContractData | null> {
    return this.http
      .get<{
        data: { contract_data: PurchaseOrderContractData | null };
      }>(`${environment.apiUrl}/customers/${customerId}/last-purchase-order-contract`)
      .pipe(map((res) => res.data.contract_data));
  }

  create(txId: number, dto: UpsertPurchaseOrderDto): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.txBase}/${txId}/purchase-order`, dto);
  }

  get(orderId: number): Observable<PurchaseOrder> {
    return this.http.get<PurchaseOrder>(`${this.base}/${orderId}`);
  }

  update(orderId: number, dto: UpsertPurchaseOrderDto): Observable<PurchaseOrder> {
    return this.http.patch<PurchaseOrder>(`${this.base}/${orderId}`, dto);
  }

  send(orderId: number): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.base}/${orderId}/send`, {});
  }

  returnToCustomer(orderId: number, comment: string): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.base}/${orderId}/return`, { comment });
  }

  confirmIdentity(orderId: number): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.base}/${orderId}/confirm-identity`, {});
  }

}
